<template>
  <div class="container">
    <div class="my-5 text-center">
      <h3 class="d-inline me-5">Email</h3>
    </div>

    <!-- #Item To Show Selector -->
    <div class="mb-5 item-amount-select">
      <p>#Item to show:</p>
      <select
        class="form-select"
        aria-label="Default select"
        v-model="itemToShow"
        @change="getData"
      >
        <option value="3">3</option>
        <option value="5">5</option>
        <option value="10">10</option>
      </select>
    </div>

    <table class="table table-hover table-striped table-bordered align-middle">
      <caption>
        Email Information
      </caption>
      <thead>
        <tr>
          <th width="10%" scope="col">Date</th>
          <th scope="col">Email</th>
          <th scope="col">Name</th>
          <th scope="col">Phone</th>
          <th width="40%" scope="col">Message</th>
          <th scope="col">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="message._id" v-for="message in data">
          <AdminEmailTable :message="message" />
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page" class="text-center">
      <ul class="pagination">
        <li class="page-item">
          <a class="page-link" @click="lastPage" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li>
          <p>Current Page: {{ page + 1 }}</p>
        </li>
        <li class="page-item">
          <a class="page-link" @click="nextPage" aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import axios from "axios";
import AdminEmailTable from "./AdminEmailTable.vue";

export default {
  name: "AdminEmail",
  components: {
    AdminEmailTable,
  },
  data() {
    return {
      data: "",
      displayModal: false,
      page: 0,
      itemToShow: 5,
    };
  },
  computed: {
    itemAmount() {
      return this.itemToShow;
    },
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
    nextPage() {
      if (this.data.length === this.itemAmount) this.page++;
      this.getData();
    },
    lastPage() {
      if (this.page > 0) {
        this.page--;
        this.getData();
      }
    },
    getData() {
      axios
        .get(
          this.$webDomain +
            "/gardenInit/GardenMessage?size=" +
            this.itemAmount +
            "page=" +
            this.page
        )
        .then((response) => {
          this.data = response.data.data;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
nav ul {
  display: inline-block;
}
nav li {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

.page-link {
  cursor: pointer;
}

.item-amount-select select {
  width: 100px;
}
</style>
